export interface FetchEnergyContractRequest {
  brand: string
  documentId: string
  sub: string
}

export enum EnergyContractState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  DISMISSED = 'DISMISSED',
  TERMINATED = 'TERMINATED',
}

export enum EnergyContractProductType {
  ELECTRICITY = 'ELECTRICITY',
  UNKNOWN = 'UNKNOWN',
}

export interface EnergyContract {
  id: string
  state: EnergyContractState
  productType: EnergyContractProductType
  supplyPointCode: string
  createDate: string
  activationDate: string
  terminationDate: string
}

export interface FetchEnergyContractResponse {
  total: number
  items: EnergyContract[]
}
